import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  width: '100%',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  minHeight: '300px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: { base: 'column', xl: 'row' },
});

export const imageContainerBaseStyles = css.raw({
  position: 'relative',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  width: '440px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  height: '280px',
  display: 'flex',
  alignItems: 'center',
});

export const imageContainerMwebStyles = css.raw({
  position: 'relative',
  width: '100%',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  height: '300px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
